import { useSidebar } from "../../contexts/SidebarContext";
import { Button } from "primereact/button";

export default function SettingsPage() {
  const { toggleSidebar } = useSidebar();

  return (
    <div>
      <div className="flex-container">
        <Button
          text
          size="small"
          severity="secondary"
          aria-label="Sidebar menu"
          icon="pi pi-bars"
          className="sidebar-toggle-button"
          onClick={toggleSidebar}
        />
        <h1 className="table-header">Ustawienia</h1>
      </div>
      <div>
        <p>Brak ustawień</p>
      </div>
    </div>
  );
}
